<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="sidebarConfig.isOpen"
    id="update-category"
  >
    <div class="mt-3 flex items-center justify-between px-6">
      <h4 class="text-2xl font-bold">Update Category</h4>
      <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <div class="sidebar-content p-6">
      <!-- <div class="update-category-avatar-container">
        <h4 class="text-lg font-bold">Category image</h4>
        <avatar-uploader class="my-avatar-uploader" v-if="sidebarConfig.isOpen" :user="serviceData" @uploaded-done="handleUploaded"></avatar-uploader>
      </div> -->
      <h4 class="font-bold text-lg mt-6 mb-4">Category name</h4>
      <div>
        <vs-input
          v-validate="'required'" name="service_name"
          placeholder="Category Name"
          v-model="service_name"
          class="w-full"
          :disabled="serviceData.type == 'combo' || serviceData.type == 'gift_card' || serviceData.type == 'product' || serviceData.type == 'custom'"
          :danger="errors.has('service_name')" danger-text="The category name field is required"
          @input="update_is_exist=false"
          v-on:keypress="formatName"
        />
        <span class="text-danger text-xs error-text-input" v-show="update_is_exist">{{errMessage}}</span>
      </div>
      <div class="pt-base">
        <h4 class="font-bold text-lg mb-3">Category color</h4>
        <ul class="clearfix flex flex-wrap">
          <li
            v-for="(color, index) in themeColors"
            :key="color"
            :style="{backgroundColor: color}"
            class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left position-relative"
            @click="updatePrimaryColor(color)"
            :class="{'blur-item': isNewColor || (index >= 0 && index < 20)}"
          >
            <i class="vs-icon material-icons text-white font-bold text-2xl translate-center" v-if="color == primaryColor">check</i>
          </li>
        </ul>
        <div>
          <h4 class="text-lg font-bold mb-4 mt-4">Status</h4>
          <ul class="switch-container">
            <li class="flex align-center">
              <vs-switch v-model="category_is_active" @click.stop="switchActive"/>
              <p class="ml-3">
                <span class="text-primary" v-if="category_is_active">Active</span>
                <span class="text-grey-custom" v-else>Inactive</span>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
      <vs-button class="mr-6" @click="submitData" style="min-width: 140px">Submit</vs-button>
      <vs-button type="border" color="danger" @click.stop="closeSidebar" style="min-width: 140px">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
export default {
  name: "vs-update-category",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue")
  },
  props: {
    sidebarConfig: {
      type: Object,
      required: true
    },
    serviceData: {
      type: Object,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    isExistName: {
      type: Boolean,
      required: true
    },
    errMessage: {
      type: String,
      default: ''
    },
    // typeCate: {
    //   type: String,
    //   required: true
    // }
  },
  data() {
    let currentColor = this.$store.getters["staffList/themeColorsCate"][0];
    if(this.serviceData && this.serviceData.color_detail) {
      currentColor = this.checkColorInList(this.serviceData.color_detail.color_code) ? this.serviceData.color_detail.color_code : this.$store.getters["staffList/themeColorsCate"][0];
    }
    return {
      number0: 0,
      name: this.serviceData.name,
      currentColor,
      themeColors: this.$store.getters["staffList/themeColorsCate"],
      itemsPerPage: 10,
      is_exist: this.isExistName,
      is_active: this.serviceData.status == 2 ? true : false,
      image: {}
    };
  },
  computed: {
    category_is_active: {
      get() {
        return this.is_active;
      },
      set(value) {
        this.is_active = value;
      }
    },
    primaryColor: {
      get()    { return this.currentColor },
      set(value) { this.currentColor = value; }
    },
    service_name: {
      get() {
        return this.name;
      },
      set(value) {
        this.name = value;
      }
    },
    update_is_exist: {
      get(){
        return this.is_exist;
      },
      set(value) {
        this.is_exist = value;
      }
    },
    id: {
      get() {
        return this.serviceData.id;
      },
      set() {}
    },
    config() {
      return this.$store.getters["auth/config"];
    },
    isNewColor() {
      return this.config && this.config.new_color == 1;
    }
  },
   watch: {
    sidebarConfig: {
      immediate: true,
      deep: true,
      handler() {
        if(this.serviceData && this.serviceData.color_detail){
          this.currentColor = this.checkColorInList(this.serviceData.color_detail.color_code) ? this.serviceData.color_detail.color_code : this.$store.getters["staffList/themeColorsCate"][0];
        //   this.customColor = this.checkColorInList(this.currentColor) ? '#FF9CBB' : this.currentColor;
        // }else{
        //    this.currentColor = this.$store.getters["staffList/themeColors"][0];
        //    this.customColor = this.checkColorInList(this.currentColor) ? '#FF9CBB' : this.currentColor;
        }
        this.name = this.serviceData.name;
        this.image = {
          image_url: this.serviceData.image_path && this.serviceData.image_path != "null" ? `${this.serviceData.image_base_url}/${this.serviceData.image_path}`: null,
          delete_image_url: null,
          image_path: this.serviceData.image_path,
          image_base_url: this.serviceData.image_base_url
        }
        if(this.sidebarConfig.isOpen) {
          document.body.classList.add('overflow-hidden');
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
        } else {
          document.body.classList.remove('overflow-hidden');
          this.$emit("CloseSidebar");
        }
      }
    }
  },
  methods: {
    handleUploaded(data) {
      this.image = data;
    },
    removeAccents(str) {
      return str.normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/đ/g, 'd').replace(/Đ/g, 'D');
    },
    formatName() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.name = this.removeAccents(this.name);
      }, 500);
    },
    switchActive(){
      this.is_active = this.is_active
    },
    checkColorInList(color) {
      let list_color = this.$store.getters["staffList/themeColorsCate"];
      if(list_color && color) {
        for(let i = 0; i < list_color.length; i++) {
          if(list_color[i].toUpperCase() == color.toUpperCase()) {
            return true;
          }
          //  if(list_color[i] == color) {
          //   return true;
          // }
        }
      }
      return false;
    },
    updatePrimaryColor(color) {
      this.primaryColor = color;
      // this.$vs.theme({ primary: color });
    },
    closeSidebar() {
      this.$emit("CloseSidebar");
    },
    submitData() {
      if(this.name != '') {
        if(this.name.toLowerCase().trim() == 'other'){
          this.$vs.notify({
            title:'Notification',
            text:'Other has already existed',
            color:'danger',
            position:'top-right'})
        }else{
          const obj = {
            id: this.id,
            name: this.removeAccents(this.name),
            color_code: this.primaryColor,
            page: this.currentPage,
            "per-page": this.itemsPerPage,
            status: this.is_active == true ? 2 : 1,
            // image_path: this.image.image_path,
            // image_base_url: this.image.image_base_url
          };
          this.$emit("UpdateCategory", obj);
        }
      }
      this.$validator.validateAll();
    }
  }
};
</script>
